import { Navigate, useLocation, useSearchParams } from "react-router-dom";

const PrivateRoute = ({
  isAllowed,
  redirectOnPermissionDenied = "/",
  children,
}) => {
  const { pathname } = useLocation();
  let [searchParams] = useSearchParams();
  const hasQuickAuth = searchParams.get("quickAuth") !== null;

  if (!isAllowed && !hasQuickAuth) {
    window.localStorage.setItem(
      "redirect",
      JSON.stringify({ path: pathname, date: Date.now(), minuteDuration: 10 }),
    );

    return <Navigate replace={true} to={redirectOnPermissionDenied} />;
  }

  return children;
};

export default PrivateRoute;
